import { z } from 'zod';

import { TSDGeneralInfoSchema } from '@e-origin/contracts';

export const tsdViewGeneralInfoSchema = TSDGeneralInfoSchema.merge(
  z.object({
    refreshCustomerData: z.boolean().optional().nullable(),
  }),
);

export type TSDViewGeneralInfoFormValues = z.infer<typeof tsdViewGeneralInfoSchema>;
